import Image from "../../../components/elements/Image";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveBookId } from "../../../redux/slice/stepSlice";
import { fetchBatchImagesByBookId } from "../../../services/mediaService";
import { setCoverImages, setImages } from "../../../redux/slice/sketchSlice";
import { saveStep } from "../../../services/stepService";
import NoImage from "../../../assets/images/no-image.png";
// import { markStepAsVisited } from "../../../services/commonService";
import { markStepAsVisited } from "../../../redux/slice/profileSlice";

const ColoringBooks = () => {
  const { session } = useSelector((state) => state.authProvider);
  const dispatch = useDispatch();
  const { myBooks } = useSelector((state) => state.profile);
  const navigate = useNavigate();

  // Function to format date in browser's timezone
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const navigateToBook = async (bookId) => {
    const batchImageRes = await fetchBatchImagesByBookId(bookId);
    if (!!batchImageRes?.docs?.data?.length) {
      dispatch(setCoverImages(batchImageRes.docs.data.filter((image) => !!image.isCover)));
      dispatch(setImages(batchImageRes.docs.data.filter((image) => !image.isCover)));
    }

    saveStep({
      userId: session?.user?._id,
      bookId,
      isCompleted: 'yes',
      // stepCode: nextStepCode?.code,
      stepCode: "Upload_Your_Cover_Photo",
    });
    dispatch(markStepAsVisited({ id: bookId, currentStepCode: 'Upload_Your_Cover_Photo' }))
    // markStepAsVisited('Upload_Your_Cover_Photo', bookId);

    dispatch(setActiveBookId({ bookId }));
    navigate("/dashboard?stepCode=Upload_Your_Cover_Photo");
  };

  // Transform myBooks data to match the display format
  const transformedBooks =
    myBooks?.map((book) => ({
      id: book._id,
      name: book.title,
      description: book.description,
      // Use cover image if available, otherwise use random static image based on book ID
      image: book.coverImage ?? NoImage,
      date: formatDate(book.createdAt),
      pages: book.pageCount ?? null, // Default pages - you might want to get this from API
      click: () => navigateToBook(book._id),
    })) || [];

  return (
    <>
      <div className="w-full sm:py-6 flex flex-col gap-4">
        {transformedBooks?.length > 0 ? (
          <>
            <div className="text-xl text-md-dark font-semibold">Coloring Book Collections</div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4  gap-2 lg:gap-4">
              {transformedBooks?.map((item, index) => (
                <button type="button" key={item.id} className="relative text-left group flex flex-col justify-between" onClick={item?.click}>
                  <div className="w-full aspect-[4/5] rounded-lg overflow-hidden shadow border border-md-pink-light-3 shadow-md-pink/20 group-hover:shadow-lg group-hover:shadow-md-pink/20 transition-all duration-300">
                    <Image src={item?.image} alt={item?.name} width={"100%"} height={"100%"} effect={"blur"} classes={"object-cover"} />
                  </div>
                  <div className="py-3 grid w-full space-y-1">
                    {item?.name && (
                      <div className=" text-sm md:text-base text-md-pink font-semibold truncate" title={item.name}>
                        {item?.name}
                      </div>
                    )}
                    <div className="flex items-center justify-between gap-2">
                      <div className="text-xs md:text-sm text-slate-500">{item?.pages > 1 ? item?.pages + " pages" : item?.pages + " page"}</div>
                      {item?.date && <div className="text-xs md:text-sm text-slate-500 ml-auto">{item?.date}</div>}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </>
        ) : (
          <div className="flex flex-col items-center justify-center h-64">
            <div className="text-lg text-slate-400 mb-2">No coloring books yet</div>
            <div className="text-sm text-slate-500">Create your first coloring book to get started!</div>
          </div>
        )}
      </div>
    </>
  );
};

export default ColoringBooks;
